<template lang="pug">
  #hotsite_menu
    .dropdown.pull-right(@click="toggleDropdown")
      button.btn.btn-default.dropdown-toggle#mobile_menu(type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true")
        span.caret
        | &nbsp;&nbsp; Navegue aqui
      ul.dropdown-menu(v-if="isOpen" aria-labelledby="mobile_menu")
        li(v-for="(link, id) of links", :key="link.id")
          router-link(v-if="link.rota", :to="{ name: link.rota }") {{ link.texto }}
          a(v-else-if="link.url", :href="link.url" target="_blank" noopener) {{ link.texto }}
    hr.-full
</template>

<script>
export default {
  props: {
    links: { type: Array, required: true }
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleDropdown () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="scss">
  #hotsite_menu {
    display: block;

    width: 100%;
    > .dropdown {

      > button {
        height: 60px;
        border-radius: 0;
      }

      &.open > button {
        background-color: #fff;
        color: inherit;
      }

      > .btn {
        border: none;
        @extend %font_bold;
        color: $text-default-color;
        font-size: 1.1rem;
        .caret { height: 10px; }
      }

      > .dropdown-menu {
        background-color: $color-grey-dark;
        border-radius: 0;
        margin-top: -1px;
        padding: 0;
        display: block;

        > li > a {
          color: white;
          padding: 10px 30px;
          font-size: 16px;
          font-weight: bold;
          &:before {
            content: "\F0DA";
            font-family: FontAwesome;
            display: inline-block;
            margin-left: -1.3em;
            width: 1.3em;
          }
        }
      }

    }

    @include media(">=desktop") {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// HotsiteMenu.vue?c554be9e